var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSymptomWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.166,
    height: 26.838,
    viewBox: "0 0 23.166 26.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symptomWhite",
    transform: "translate(-1163.598 -191.031)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x1: 4.337,
    transform: "translate(1177 207.053)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x1: 4.337,
    transform: "translate(1177 208.453)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M1180.214,209.478a1.281,1.281,0,1,0,2.563,0,.177.177,0,0,0-.02-.1,1.576,1.576,0,0,0,1.4-1.557,1.6,1.6,0,0,0-1.419-1.577.7.7,0,0,0,.019-.2,1.281,1.281,0,0,0-2.563,0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M1180.588,203.78a3.567,3.567,0,0,1,1.7-.2,2.02,2.02,0,0,1,1.4.907,3.628,3.628,0,0,0,.335.611,3.9,3.9,0,0,0,.927.651,2.228,2.228,0,0,1,.926,1.538,2.143,2.143,0,0,1-.552,1.7,2.365,2.365,0,0,0,1.439-1.971,2.43,2.43,0,0,0-1.124-2.189,4.473,4.473,0,0,1-.827-.512,5.282,5.282,0,0,1-.474-.789,1.983,1.983,0,0,0-1.873-.769,4.2,4.2,0,0,0-1.873,1.025",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M1173.352,193.784a4.028,4.028,0,0,0,.375,2.307c.808,1.262,2.543,4.081,3,4.811a1.543,1.543,0,0,1,.256.709,1.1,1.1,0,0,1-.966,1.223c-1.459.394-1.7,1.242-1.577,1.833a4.387,4.387,0,0,1,.157,1.183,1,1,0,0,1-1.084.868,2.934,2.934,0,0,1-1.932-.927",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M1173.432,191.734s2.563,3.174-5.856,3.352",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M1171.853,197.826a2.513,2.513,0,0,1-1.715.611,2.4,2.4,0,0,1-1.656-.749",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M1164.3,210.149a11.836,11.836,0,0,0,1.656,1.163,11.172,11.172,0,0,0,5.56,1.42h.039c2.405,0,2.445-1.144,2.287-1.776a2.229,2.229,0,0,1,.118-1.517,2.079,2.079,0,0,1,.2-.374.02.02,0,0,1,.02-.021.8.8,0,0,0-.69-1.241,4.271,4.271,0,0,1-2.426-.769",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M1169.094,212.475a5.463,5.463,0,0,0-1.262,4.791",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M1172.071,204.8a1.2,1.2,0,0,0-1.519-.414,1.035,1.035,0,0,0-.236,1.42,1.37,1.37,0,0,0-.355,2.445,1.947,1.947,0,0,1-1.538-.375,1.215,1.215,0,0,1-.295-1.479c.216-.355.65-.552.848-.907a6.046,6.046,0,0,0,.236-1.025,1.49,1.49,0,0,1,1.557-1.064A1.528,1.528,0,0,1,1172.071,204.8Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomWhite);
export default __webpack_public_path__ + "static/media/symptomWhite.ea26ae74d36b9a0bc703ed704730f671.svg";
export { ForwardRef as ReactComponent };